module.exports = __webpack_public_path__ + "img/byyw_.e5e6fe7b.png";